import { DownloadIcon } from 'lucide-react'
import { useEffect, useState } from 'react'
import { findUserDefaultDownload, getDownloadLinksDesktop } from './downloads'
import { GitHubRelease } from '@/lib/github'
import { useTermsOfService } from './useTermsOfService'
import { Button } from '@/components/ui/Button'
import { LinkButton } from '@/components/ui/LinkButton'
import { cn } from '@/utilities/ui'
import { Text } from '@/components/ui/text'

type Props = {
  daemon: 'renterd' | 'hostd' | 'walletd'
  release: GitHubRelease
  testnetOnly?: boolean
}

export function DownloadDesktopSelect({ daemon, release, testnetOnly }: Props) {
  const downloadLinks = getDownloadLinksDesktop(release)
  const { accepted } = useTermsOfService()

  const [download, setDownload] = useState(downloadLinks[0])

  useEffect(() => {
    const d = findUserDefaultDownload(downloadLinks)
    if (d) {
      setDownload(d)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!release || !download) {
    return null
  }

  return (
    <div className="flex flex-col lg:flex-row items-center">
      <div className="flex items-center w-full">
        <div className="h-[48px] px-[15px] bg-powder flex items-center justify-center text-body-sm font-diatype">
          <Text className="font-diatype text-body-sm">
            {release.tag_name.replace(`${daemon}@`, 'v')}
          </Text>
        </div>
        <select
          value={download.link}
          className={cn(
            'flex-1 h-[48px] px-[10px] bg-rock-2',
            'transition-colors focus-visible:outline-hidden',
            'disabled:pointer-events-none disabled:opacity-50',
            'focus-ring',
            'enabled:cursor-pointer',
          )}
          onChange={(e) => {
            const value = e.target.value
            const d = downloadLinks.find((i) => i.link === value)
            if (d) {
              setDownload(d)
            }
          }}
        >
          {downloadLinks.map((i) => (
            <option key={i.link} value={i.link}>
              {testnetOnly ? `Testnet only: ${i.title}` : i.title}
            </option>
          ))}
        </select>
      </div>
      {accepted ? (
        <LinkButton href={accepted ? download.link : ''} className="w-full lg:w-auto">
          <DownloadIcon />
          Download
        </LinkButton>
      ) : (
        <Button
          onClick={() => alert('You must accept the Terms of Service to download the software.')}
          className="w-full lg:w-auto"
        >
          <DownloadIcon />
          Download
        </Button>
      )}
    </div>
  )
}
